import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { ISectionLayoutProps } from './SectionLayout.types';

import './SectionLayout.styles.scss';

const { Text } = Typography;

const SectionLayout = ({
  children,
  className,
  title,
  titleSize = 36,
  noPaddings,
  noPaddingsY,
  headerCentered,
  bodyCentered,
  headerVerticalAlign = 'center',
  verticalCentered,
  rightHeaderComponent,
  leftHeaderComponent,
  gap = 16,
  titleGap = 24,
  ...props
}: ISectionLayoutProps) => {
  const { t } = useTranslation();

  const centeredHeaderClass = headerCentered ? 'np-section-layout__header--center' : '';
  const centeredBodyClass = bodyCentered ? 'np-section-layout__body--center' : '';
  const verticalCenteredClass = verticalCentered ? 'np-section-layout--center' : '';

  const showHeader = title || leftHeaderComponent || rightHeaderComponent;

  return (
    <div
      style={{ padding: noPaddings && 0, paddingTop: noPaddingsY && 0, paddingBottom: noPaddingsY && 0, gap: titleGap }}
      className={`np-section-layout ${verticalCenteredClass} ${className}`}
      {...props}
    >
      {showHeader && (
        <div className={`np-section-layout__header ${centeredHeaderClass}`} style={{ alignItems: headerVerticalAlign }}>
          <div className="np-section-layout__header-title-wrapper" style={{ alignItems: headerVerticalAlign }}>
            {title && (
              <Text style={{ fontSize: titleSize }} className={`np-section-layout__title`}>
                {t(title)}
              </Text>
            )}

            {leftHeaderComponent}
          </div>

          {rightHeaderComponent}
        </div>
      )}

      <div style={{ gap }} className={`np-section-layout__body ${centeredBodyClass}`}>
        {children}
      </div>
    </div>
  );
};

export default SectionLayout;
